module.exports = __webpack_public_path__ + "static/media/org-join-notify.02dd6def.svg";